module.exports = __webpack_public_path__ + "assets/img/20_1001_big.69566a3d.jpg";